const incidentFollowUps = (() => {
  let followUpTable, followUpData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident FollowUps
  //-------------------------------------------------------------------------------

  function getIncidentfollowUpView() {
    const frag = document.createDocumentFragment();
    
    followUpTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = followUpTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addfollowUpBtnDiv = document.createElement('div');
    const addfollowUpBtn = new Button({
      text: 'ADD NEW FOLLOW-UP',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(followUpTable);
    if ($.session.SetupInsert) {
      addfollowUpBtn.button.style.float = 'right';
      addfollowUpBtn.renderTo(addfollowUpBtnDiv);
      frag.append(addfollowUpBtnDiv);
    }

    const tablefollowUpData = followUpData
      .map(p => {
        return {
          values: [p.followUpName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showfollowUpPopup(p);
          },
          endIconCallback: () => handlefollowUpDelete(p),
        };
      });

    table.populate(followUpTable, tablefollowUpData);
    table.sortTableByHeader(followUpTable);

    addfollowUpBtn.onClick(e => {
      showfollowUpPopup();
    });

    return frag;
  }

  // Incident FollowUps
  //-------------------------------------------------------------------------------

  function showfollowUpPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const followUpForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    followUpForm.onKeyup(() => {
      followUpForm.inputs['cName'].setValidtyError('');
      followUpForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(followUpForm);
    });
    followUpForm.onChange(event => {
      followUpForm.inputs['cName'].setValidtyError('');
      followUpForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(followUpForm);
    });

    followUpForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentFollowUpData', {
          id: rowData ? rowData.followUpId : 0,
          followUpName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentFollowUpDataResult;
      const newID = resp.followUpId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This follow-up type already exists.', followUpForm);
        followUpForm.buttons['submit'].toggleDisabled(true);
        followUpForm.buttons['cancel'].toggleDisabled(true);
      } else {
        followUpForm.clear();
        POPUP.hide(popup);
        await getfollowUpData();
        updatefollowUpTable();
      }
    });

    followUpForm.onCancel(event => {
      followUpForm.clear();
      followUpForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    followUpForm.renderTo(popup);

    POPUP.show(popup);

    followUpForm.populate({
      cName: rowData ? rowData.followUpName : '',
    });

    followUpForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      followUpForm.disableFormInputs();
    }
  }

  async function handlefollowUpDelete(row) {
    const rowData = followUpData.find(a => a.followUpId == row.followUpId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This follow-up type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this follow-up type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentFollowUpData', {
            token: $.session.Token,
            followUpId: row.followUpId,
          });

          await getfollowUpData();
          updatefollowUpTable();
        }
      });
    }
  }
  function updatefollowUpTable() {
    const tablefollowUpData = followUpData
      .map(p => {
        return {
          values: [p.followUpName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showfollowUpPopup(p);
          },
          endIconCallback: () => handlefollowUpDelete(p),
        };
      });

    table.populate(followUpTable, tablefollowUpData);
  }

  async function getfollowUpData() {
    const datafollowUp = await _UTIL.fetchData('getIncidentFollowUp');
    followUpData = datafollowUp.getIncidentFollowUpResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getfollowUpData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Follow-Ups';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Follow-Ups') {
      viewMarkup = getIncidentfollowUpView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
